// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import AlertTriangle from "@insite/mobius/Icons/AlertTriangle";
import Link from "@insite/mobius/Link";
import Tooltip from "@insite/mobius/Tooltip/Tooltip";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { SectionContainer, SectionTitle } from "@keller/App/Widgets/DesignSystem/DesignSystem.helpers";
import { longText } from "@keller/App/Widgets/DesignSystem/DummyData/DummyData";
import React, { FC } from "react";
import { css } from "styled-components";

interface TooltipTabStyles {
    titleGridItem?: GridItemProps;
    gridItem?: GridItemProps;
    tooltipWrapper?: InjectableCss;
}

const tooltipTabStyles: TooltipTabStyles = {
    titleGridItem: {
        width: 12,
    },
    gridItem: {
        width: 12,
        css: css`
            flex-wrap: wrap;
            padding-bottom: 40px;
        `,
    },
    tooltipWrapper: {
        css: css`
            display: flex;
            justify-content: space-between;
            width: 100%;
            margin-top: 20px;
            flex-wrap: wrap;
        `,
    },
};

const styles = tooltipTabStyles;
const TooltipTab: FC = props => {
    return (
        <SectionContainer>
            <GridItem {...styles.titleGridItem}>
                <SectionTitle>{translate("Tooltip")}</SectionTitle>
            </GridItem>
            <GridItem width={12}>
                <StyledWrapper {...styles.tooltipWrapper}>
                    <StyledWrapper>
                        <Typography>Tooltip with long text and default icon</Typography>
                        <Tooltip text={longText} />
                    </StyledWrapper>
                    <StyledWrapper>
                        <Typography>Tooltip with custom icon</Typography>
                        <Tooltip iconProps={{ src: AlertTriangle }} text="Night mode" />
                    </StyledWrapper>
                    <StyledWrapper>
                        <Typography>Tooltip with trigger component - </Typography>
                        <Tooltip triggerComponent={<Link href="#">Click here</Link>} text="link trigger" />
                    </StyledWrapper>
                </StyledWrapper>
            </GridItem>
        </SectionContainer>
    );
};

export default TooltipTab;
